module.exports = __webpack_public_path__ + "img/38.a5b4782e.jpg";